import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeIndentPipe' })
export class RemoveIndentPipe implements PipeTransform {
  public transform(text: string = ''): string {
    return text.replace(/text-indent: -?\d+\.\d+pt/g, 'text-indent: 0');
  }
}
